type Args = {
  id: string;
  email: string;
  name: string;
  phone: string | null | undefined;
  mainOffice: string | null | undefined;
  first_admin: boolean | null | undefined;
  signed_up_at: number | null | undefined;
};

const getUserDetails = ({
  id,
  email,
  name,
  phone,
  mainOffice,
  first_admin,
  signed_up_at,
}: Args) =>
  // Do not send dathuis details to intercom (as our e2e tests create loads of e-mails)
  email.endsWith('@dathuis.nl') || email.endsWith('@bndl.nl')
    ? {
        email: 'internal@dathuis.nl',
        user_id: 'internal-dathuis-person-id',
        name: 'Internal BNDL',
        phone: '',
        main_office: '',
        first_admin: undefined,
        signed_up_at: undefined,
      }
    : {
        email,
        user_id: id,
        name,
        phone: phone ? phone : '',
        main_office: mainOffice ? mainOffice : '',
        first_admin: first_admin,
        signed_up_at: signed_up_at,
      };

export default getUserDetails;
